import { render, staticRenderFns } from "./detailPeserta.vue?vue&type=template&id=3c0e29e0"
import script from "./detailPeserta.vue?vue&type=script&lang=js"
export * from "./detailPeserta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports